export const ADMITAD_QUERY_PARAM_NAME = 'admitad_uid';
